import { useEnvStore } from '@remote/store/env'
import qs from 'qs'
/**
 * 穿透机制
 */
import global from '@remote/store/constantStore'
// import { request } from '@remote/api/request'
import { parseSearch } from '@remote/utils'
import axios, { Method } from 'axios'
import { store } from '@remote/store'
import { safeJSONParse } from '@shared/utils'
import { SSOconfig } from './config'
import request from '@remote/api/adapter'
interface ProxyParams {
  proxyUrl: string
  proxyMethod?: Method
  proxyParams?: Record<string, any>
  proxyData?: Record<string, any>
  headers?: Record<string, any>
  space?: string
}
export function getDeviceSpace () {
  const curDeviceConfig = global.curDeviceConfig
  const deviceConfig: any = safeJSONParse(curDeviceConfig)
  return deviceConfig.device_space
}

/**
 * 缓存INNER_API的结果
 */
let innerAPIResult: API_FILE.DriveApp | null = null
/**
 * 用于做并发控制
 */
let innerAPIPromise: Promise<void> | null = null
/**
 * 上一次发请求的space
 */
let lastSpace = ''

export async function cacheInnerAPIResult () {
  if (innerAPIResult !== null) return // 穿透已有结果
  if (innerAPIPromise === null) { // 且没有获取中的穿透链接
    innerAPIPromise = new Promise((resolve, reject) => {
      const envStore = useEnvStore()
      const space = envStore.space || global.fromSpace || store?.state?.fromSpace
      request(
        '/drive/v1/apps/INNER_API',
        { space },
        { method: 'GET'},
      ).then(([err, result]: [Error, API_FILE.DriveApp]) => {
        if (err) {
          reject(new Error('请确认设备在线后再重试'))
          innerAPIResult = null
          innerAPIPromise = null
        }

        innerAPIResult = result
        resolve()
      }).catch(() => {
        reject(new Error('请确认设备在线后再重试'))
        innerAPIResult = null
        innerAPIPromise = null
      })
    })
  }
  return innerAPIPromise
}

/**
 * 切换设备的时候要清除缓存
 */
export function flushInnerAPICache () {
  console.log('清除INNER_API缓存')
  innerAPIResult = null
  innerAPIPromise = null
}

// 通过应用信息接口调用穿透链接
export async function getInnerApiProxy (params: ProxyParams) {
  const envStore = useEnvStore()
  const space = envStore.space || global.fromSpace || store?.state?.fromSpace
  if (space !== lastSpace) {
    // space 切换时，需要刷新缓存 --- 因为设备变了。
    flushInnerAPICache()
    lastSpace = space
  }
  if (innerAPIResult === null) {
    await cacheInnerAPIResult()
  }

  if (innerAPIResult === null) {
    throw new Error('获取穿透链接失败，请重试')
  }

  if (innerAPIResult.link) {
    const device_space = getDeviceSpace()
    const urlObj = new URL(innerAPIResult.link)
    const { proxyUrl = '', proxyMethod = 'get', proxyParams = {}, proxyData = {}, headers = {} } = params
    const search = parseSearch(urlObj.search)
    const instance = axios.create({
      baseURL: urlObj.origin,
    })
    const publicHeaders = {
      'x-client-id': SSOconfig.clientId,
    }

    const isXlBox = global.isXlBox
    const url = urlObj.pathname + proxyUrl
    const _headers = {
      ...publicHeaders,
      ...headers,
      Target: isXlBox ? space : '',
    }
    const _params = { device_space, ...proxyParams, ...search }

    return isXlBox ? request(url, _params, { headers: _headers }) : instance(url, {
      method: proxyMethod,
      timeout: 5000,
      headers: _headers,
      params: _params,
      data: proxyData,
      paramsSerializer: proxyMethod.toUpperCase() === 'GET' ? (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      } : undefined,
    })
  }
  throw new Error('请重试')
}

export async function getInnerApiProxyData (params: ProxyParams) {
  try {
    const result = await getInnerApiProxy(params)
    // console.log('getInnerApiProxyData=======>', result)
    if (result?.data) {
      return result.data
    }
    return {}
  } catch (err) {
    throw new Error(JSON.stringify(err))
  }
}

/**
 * 通过穿透调用套件退出
 * 目前只有从设备列表里调用退出，才会有带上不是当前设备的space和deviceSpace请求的场景。
 * 感觉场景比较特殊，因此这里就没有做抽象。
 */
export async function signOutFromInnerProxy (space: string, deviceSpace: string) {
  // 获取穿透链接
  const [err, result]: [Error, API_FILE.DriveApp] = await request(
    '/drive/v1/apps/INNER_API',
    { space },
    { method: 'GET' },
  )

  if (err) {
    throw new Error('无法连接到设备，请确认设备在线后重试')
  }

  // 发起穿透请求
  if (result.link) {
    const urlObj = new URL(result.link)
    const instance = axios.create({
      baseURL: urlObj.origin,
    })
    return instance(urlObj.pathname + 'auth/signout', {
      method: 'POST',
      timeout: 5000,
      params: {
        device_space: deviceSpace,
      },
      headers: {
        'x-client-id': SSOconfig.clientId,
      },
    })
  }
}

